import { z } from 'zod';
export const GetTemplateApiSchema = {
    params: z.object({
        id: z.string(),
    }),
};
export const GetTemplateRequestSchema = GetTemplateApiSchema.params;
